<template>
  <section class="detail-bonus-card-info">
    <h4 class="detail-bonus-card-info__history-title">История операций</h4>
    <bonus-card-transaction-table v-bind:transactions="detailBonusCard.transactions" />
  </section>
</template>

<script>
import { DetailBonusCard } from '@/mixins/loyaltySystemMixin';
import BonusCardTransactionTable from '@/components/BonusCardTransactionTable.vue';

export default {
  /**
   * @description Компонент информации о бонусной карте
   */
  name: 'DetailedBonusCardInfo',
  components: { BonusCardTransactionTable },
  props: {
    /**
     * @description Детализированная бонусная карта
     * @type {PatientLoyaltyCard}
     */
    detailBonusCard: {
      type: DetailBonusCard,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-bonus-card-info {
  font-family: Roboto, sans-serif;
  &__history-title {
    margin-bottom: 10px !important;
    font-weight: 500;
    color: #192a3e;;
  }
}

</style>
